import FnrIconButton from "UI/FnrIconButton";
import FnrOpacityToggle from "UI/FnrOpacityToggle";

import { useFnrPencilEditInputContext } from "../FnrPencilEditInput";

const CancelButton = () => {
  const {
    setIsEditing,
    labelSuffix,
    iconButtonProps,
    isEditing,
    onCancel,
    cancelButtonRef,
  } = useFnrPencilEditInputContext();

  const handleClick = () => {
    setIsEditing(false);
    if (onCancel) onCancel();
  };
  return (
    <FnrOpacityToggle show={isEditing} scale>
      <FnrIconButton
        size="sm"
        aria-label={`cancel-${labelSuffix}`}
        icon="times fas"
        onClick={handleClick}
        ref={cancelButtonRef}
        {...iconButtonProps}
      />
    </FnrOpacityToggle>
  );
};

export default CancelButton;
